import { createAction } from '@reduxjs/toolkit';

export const summaryActions = {
    activityFilterChanged: createAction<string[]>('monitor/filter/ACTIVITY_FILTER_CHANGED'),
    assetTypeFilterChanged: createAction<string[]>('monitor/filter/ASSET_TYPE_FILTER_CHANGED'),
    notificationFilterChanged: createAction<string[]>('monitor/filter/NOTIFICATION_FILTER_CHANGED'),
};
